<template>
  <div class="grade-record-container">
    <div class="page-header">
      <h2 class="page-title">我的成绩记录</h2>
    </div>

    <div class="page-content">
      <!-- 筛选条件 -->
      <div class="filter-section">
        <el-card class="card">
          <h3 class="card-title">查询选项</h3>
          <el-form :inline="true" :model="filterForm" class="filter-form">
            <el-form-item label="学期">
              <el-select 
                v-model="filterForm.semester_id" 
                placeholder="请选择学期"
                @change="handleSemesterChange"
                clearable>
                <el-option
                  v-for="semester in semesters"
                  :key="semester.id"
                  :label="semester.semester_name"
                  :value="semester.id">
                </el-option>
              </el-select>
            </el-form-item>


            <el-form-item>
              <el-button type="primary" @click="handleFilter">查询</el-button>
              <el-button @click="resetFilter">重置</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </div>

      <!-- 成绩表格 -->
      <el-card class="table-card">
        <el-table
          v-loading="loading"
          :data="gradeList"
          style="width: 100%"
          border
          :header-cell-style="{background:'#f5f7fa', color:'#606266', fontWeight: '500'}"
          empty-text="暂无数据">
          <el-table-column
            prop="semester_name"
            label="学期"
            width="150">
          </el-table-column>
          <el-table-column
            prop="course_name"
            label="课程名称"
            min-width="200">
          </el-table-column>
          <el-table-column
            prop="course_code"
            label="课程代码"
            width="120">
          </el-table-column>
          <el-table-column
            prop="course_credit"
            label="学分"
            width="80">
          </el-table-column>
          <el-table-column
            prop="score_type"
            label="成绩类型"
            width="100">
          </el-table-column>
          <el-table-column
            prop="score_category"
            label="成绩类别"
            width="100">
          </el-table-column>
          <el-table-column
            prop="score_value"
            label="成绩"
            width="100">
          </el-table-column>
        </el-table>

        <!-- 分页器 -->
        <div class="pagination-container">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import axiosInstance from '@/api/axiosInstance'
import api from '@/api/index'

export default {
  name: 'GradeRecord',
  data() {
    return {
      // 筛选表单
      filterForm: {
        semester_id: '',
        course_id: ''
      },
      // 学期和课程选项
      semesters: [],
      courseOptions: [],
      courseLoading: false,
      // 表格数据
      gradeList: [],
      // 分页
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // 加载状态
      loading: false
    }
  },
  methods: {
    // 获取基础数据
    async fetchBaseData() {
      try {
        const response = await axiosInstance.get(api.getSemesters)
        if (response.data.status === 'success') {
          this.semesters = response.data.data
        }
      } catch (error) {
        console.error('获取学期数据失败:', error)
        this.$message.error('获取学期数据失败')
      }
    },


    // 查询数据
    async fetchGrades() {
      this.loading = true
      try {
        const response = await axiosInstance.get(api.queryStudentGrades, {
          params: {
            ...this.filterForm,
            page: this.currentPage,
            page_size: this.pageSize
          }
        })
        
        if (response.data.status === 'success') {
          this.gradeList = response.data.data.items
          this.total = response.data.data.total
        } else {
          this.$message.error(response.data.message || '获取数据失败')
        }
      } catch (error) {
        console.error('获取数据失败:', error)
        this.$message.error('获取数据失败')
      } finally {
        this.loading = false
      }
    },

    // 处理筛选
    handleFilter() {
      this.currentPage = 1
      this.fetchGrades()
    },

    // 重置筛选
    resetFilter() {
      this.filterForm = {
        semester_id: '',
        course_id: ''
      }
      this.courseOptions = []
      this.handleFilter()
    },

    // 处理分页
    handleSizeChange(val) {
      this.pageSize = val
      this.fetchGrades()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.fetchGrades()
    }
  },
  mounted() {
    this.fetchBaseData()
    this.fetchGrades()
  }
}
</script>

<style scoped>
.grade-record-container {
  padding: 20px;
}

.page-header {
  margin-bottom: 20px;
}

.page-title {
  font-size: 22px;
  color: #303133;
  margin: 0;
  font-weight: 500;
}

.card {
  margin-bottom: 20px;
}

.card-title {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  margin: 0 0 15px 0;
}

.filter-section {
  margin-bottom: 20px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.el-select {
  width: 200px;
}

.el-form-item {
  margin-right: 20px;
  margin-bottom: 15px;
}
</style> 